import ArtworkFileRow from './ArtworkFileRow';

export default ArtworkFileRow;
